import { useQuery } from "@tanstack/react-query"
import { CustomerSentimentQuery } from "../lib/customerSentimentQuery"

export function useCustomerSentimentQuery(...args: Parameters<typeof CustomerSentimentQuery>) {
  return useQuery(CustomerSentimentQuery(...args))
}
